(function () {
  const selectors = {
    componentVideo: '.component-video',
    videoDesktop: '.autoplay-custom.desktop',
    videoMobile: '.autoplay-custom.mobile',
  };

  const viewportMargin = 10;
  const componentVideos = document.querySelectorAll(selectors.componentVideo);
  const isMobileMode = isMobile();
  let playVisibleVideosTimeout;

  function init() {
    setEventListeners();
    setTimeout(playVisibleVideos, 300);
  }

  function setEventListeners() {
    window.addEventListener('resize', playVisibleVideos);
    window.addEventListener('DOMContentLoaded', () => setTimeout(playVisibleVideos, 300));
    window.addEventListener(
      'scroll',
      () => {
        clearTimeout(playVisibleVideosTimeout);
        playVisibleVideosTimeout = setTimeout(playVisibleVideos, 200);
      },
      { passive: true }
    );
  }

  function playVisibleVideos() {
    componentVideos.forEach((componentVideo) => {
      const desktopVideo = componentVideo.querySelector(selectors.videoDesktop);
      const mobileVideo = componentVideo.querySelector(selectors.videoMobile);
      const isVisible = elementIsVisible(componentVideo, viewportMargin);

      if (isVisible) {
        if (isMobileMode && mobileVideo) {
          playVideo(mobileVideo);
          pauseVideo(desktopVideo);
        } else {
          playVideo(desktopVideo);
          if (mobileVideo) pauseVideo(mobileVideo);
        }
      } else {
        pauseVideo(desktopVideo);
        if (mobileVideo) pauseVideo(mobileVideo);
      }
    });
  }

  function playVideo(video) {
    if (!video || !video.paused) return;
    video.muted = true;
    video.setAttribute('playsinline', '');

    const tryPlay = () => {
      video.play().catch((error) => {
        console.warn('Play error:', error);
        if (error.name === 'NotAllowedError' || error.name === 'AbortError') {
          setTimeout(tryPlay, 200);
        }
      });
    };

    setTimeout(tryPlay, 100);
  }

  function pauseVideo(video) {
    if (video && !video.paused) {
      video.pause();
      video.currentTime = 0;
    }
  }

  function isMobile() {
    return window.matchMedia('(max-width: 739px)').matches;
  }

  function elementIsVisible(el, margin = 0) {
    if (!el) return false;
    const rect = el.getBoundingClientRect();
    return (
      rect.bottom + margin >= 0 &&
      rect.right + margin >= 0 &&
      rect.top - margin <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.left - margin <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  init();
})();
